import HorizontalTileList from "./HorizontalTileList";
export default HorizontalTileList;
export * from "./HorizontalTileList";
